module.exports = __webpack_public_path__ + "img/tkbgc@2x.9e99f522.png";